import clsx from "clsx";

type FooterProps = {
  linkClassName?: string;
};

export const Footer = ({ linkClassName = "link underline" }: FooterProps) => {
  return (
    <footer className="grid grid-cols-4 gap-4">
      <a
        href="https://singandspeak4kids.com/privacy-policy"
        target="_blank"
        rel="noreferrer"
        className={clsx("text-center", linkClassName)}
      >
        Privacy Policy
      </a>

      <a
        href="https://singandspeak4kids.com/terms-of-service"
        target="_blank"
        rel="noreferrer"
        className={clsx("text-center", linkClassName)}
      >
        Terms of Service
      </a>

      <div className="text-center">
        &copy; {new Date().getFullYear()}{" "}
        <a
          href="https://singandspeak4kids.com/about-us"
          target="_blank"
          rel="noreferrer"
          className={linkClassName}
        >
          iQsonics LLC
        </a>
      </div>

      <p className="text-center">All Rights Reserved</p>
    </footer>
  )
}
